module.exports = __webpack_public_path__ + "static/media/BonfantiXL190CE.3f9c855f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/stores/presets/photos/BonfantiXL190CE.jpg
// module id = 150
// module chunks = 0